import React, { memo, Suspense } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import mainRoutes, { common } from '../../../routes/main';
import Loading from '../Loading/Loading';

const Content = () => (
  <Switch>
    {mainRoutes.map(route => (
      <Route
        key={route.path}
        path={route.path}
        exact={route.exact}
        name={route.name}
        render={props => (
          <Suspense fallback={<Loading />}>
            <route.ContentComponent {...props} bodyClass={route.bodyClass} />
          </Suspense>
        )}
      />
    ))}
    <Route path="/" exact render={() => <Redirect to="/home" />} />
    {common.map(route => (
      <Route
        key={route.path}
        path={route.path}
        name={route.name}
        render={props => (
          <Suspense fallback={<Loading />}>
            <route.ContentComponent {...props} bodyClass={route.bodyClass} />
          </Suspense>
        )}
      />
    ))}
  </Switch>
);

export default memo(Content);
